module.exports = __webpack_public_path__ + "files/bca263be9acd1df84b988b02c621b8ca.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-152x152.png
// module id = 1966
// module chunks = 60